import React from 'react';
/*
import {
  hf,
  hfDTM,
  ht,
  cr,
  gs,
  a,
  f,
//  BarC,
  useLdrz,
  useMsgz,
  BoxC,
  BtnC,
  IptC,
  LblC,
  LgnMailC,
  MsgC,
  RootC,
  GridC,
  TextC,
  cmLSG,
  useGblz,
} from 'lib';
*/
import * as IptC from "./_ccbIptC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as LblC from "./_cccLblC";
import * as MsgC from "./_cccMsgC";
import * as LgnMailC from "./_ccmLgnMailC";
import * as RootC from "./_ccmRootC";
import * as f from "./_cmFTH"; // 廃止予定
import * as cmLSG from "./_cmLSG";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import { useLdrz } from "./_csLdr";
import { useMsgz } from "./_csMdlMsg";
import * as ht from './_ht';
import * as hf from './_hf';
import * as hfDTM from './_hfDTM';


import * as icm from './icm';

import IccvFtr from './IccvFtr';

let $cky = true;

let $icn1 = '';
let $icn2 = '';

export const N = (pz: {
  sPz: ht.dz,
}) => {

  const _gUserz = gs.useUserz();
  const _gStgz = gs.useStgz();

  const _sLdrz = useLdrz();
  const _sMsgz = useMsgz();

  const _setI18rab100s = () => {
    const _i18rab100s = icm.grtI18rab100s($icn1, $icn2);
    pz.sPz.set({
      i18rab100s: _i18rab100s,
    })
  };

 React.useEffect(() => {
    cmLSG.chkAsync()
    .then((_b: ht.b) => {
      $cky = _b;
    });
  }, [
  ]);

  let _bLgn = false;
  if (
    _gStgz.crt.S03031213 == '1' &&
    (
      hfDTM.getNow() < _gStgz.crt.S03031313 ||
      hfDTM.getNow() > _gStgz.crt.S03031323
    )
  ) _bLgn = true;

  return (
    cr.c(RootC.N, {
      key: -10,
      abtType: 'dtpCmnz',
      bdyCz: {
        boxStlz: a(`f/n`),
        oClds: [

          cr.c(GridC.N, {
            key: -10,
            abtType: 'lgnCmnz',
            boxStlz: 
              cr.chkDvc() == 'p' ?
                undefined
              : a('f/n fd/csc'),
            lineCs: [
              {
//                boxStlz: a(`f/1`),
                boxStlz: a('dw/f sc/bl7'),
                cellCs: [
                ]
              },
              {
                boxStlz: a('dw/f dh/10 f/n mb/4 sc/bl7'),
                cellCs: [
                  {
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        abtType: 'lgnHdgDntz',
                        textz: {
                          pfx: `【${_gUserz.crt._20rz?._pfx ?? ''}】 施設利用予約`,
                          stlz: a('ta/c tc/lt1'),
                        },
                      }),
                    ]
                  }
                ]
              },
              {
                boxStlz: a('dw/f dwx/100 f/n mb/4 ph/2'),
                cellCs: [                
                  {
                   boxStlz: a('bc/lt3 br/1 bw/2 dw/f fd/ccc p/2'),
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        textz: {
                          pfx: _gStgz.crt.S03031111
                        },
                      }),

                    ]
                  }
                ]
              },
              _bLgn ?
              {
                boxStlz: a('f/n mb/4 ph/2'),
                cellCs: [
                  {
                    oClds: [

                      cr.c(MsgC.N, {
                        key: -10,
                        abtType: 'lgn1Cmnz',
                        cz: {
                          ls: [
                            {
                              mkrCz: {
                                textz: {
                                  pfx: '▼',
                                }
                              },
                              msgCz: {
                                textz: {
                                  pfx: '登録したメールアドレスを入力し、[送る] ボタンを押してください。',
                                },
                              }
                            },
                            {
                              mkrCz: {
                                textz: {
                                  pfx: '',
                                }
                              },
                              msgCz: {
                                textz: {
                                  pfx: 'ログイン用「確認コード」が記されたメールが、このアドレス宛に届きますので、ご確認ください。',
                                },
                              }
                            },
                          ]
                        }
                      }),

                    ]
                  }
                ]
              }
              : null,
              _bLgn ?
              {
                boxStlz: a('f/n fd/ccc mb/4 ph/2'),
                cellCs: [
                  {
                    oClds: [

                      cr.c(LblC.N, {
                        key: -10,
                        abtType: 'vclDntz',
                        boxStlz: a('mb/2'),
                        lblCz: {
                          textz: {
                            pfx: '団体番号',
                          },
                        },
                        cttCz: {
                          boxStlz: a('fd/rsc'),
                          oClds: [
                            cr.c(IptC.S, {
                              key: -10,
                              cz: {
                                bEdit: true,
                                iptType: 'text',
                                vle: $icn1,
                                onChg: (_s: ht.s) => {
                                  $icn1 = _s;
                                  _setI18rab100s();
                                }
                              },
                              iptStlz: a('dw/8 ta/c'),
                            }),
                            cr.c(IptC.S, {
                              key: -20,
                              cz: {
                                bEdit: true,
                                iptType: 'text',
                                vle: $icn2,
                                onChg: (_s: ht.s) => {
                                  $icn2 = _s;
                                  _setI18rab100s();
                                }
                              },
                              iptStlz: a('ta/c'),
                            })
                          ],
                        }
                      }),

                      cr.c(LgnMailC.S, {
                        key: -20,
                        sPz: pz.sPz,
                        cz: {
                          ccd: `bl7`,
                          grtCfmz: (_dz: ht.dz) => ({
                            cdn: `_10rt1100i = 10 AND (
                                 _icn = (SELECT _fst || '_1' FROM i18rs WHERE ${f.vdd()} AND i18rab100s='${pz.sPz.crt.i18rab100s}' AND i18ra4110s='${_dz.eml}')
                              OR _icn = (SELECT _fst || '_2' FROM i18rs WHERE ${f.vdd()} AND i18rab100s='${pz.sPz.crt.i18rab100s}' AND i18ra4210s='${_dz.eml}')
                              OR _icn = (SELECT _fst || '_3' FROM i18rs WHERE ${f.vdd()} AND i18rab100s='${pz.sPz.crt.i18rab100s}' AND i18ra4310s='${_dz.eml}')
                            )` 
                          }),
                          bfrSend: async () => {
                            _sLdrz.show();
                            const _b = await hf.ectSrlAsync([
                              async () => {
                                let _b = true;
                                if (
                                  !hf.f($icn1) || !hf.f($icn2)
                                ) _b = false;
                                if (!_b) {
                                  _sMsgz.show({
                                    textCz: {
                                      textz: {
                                        pfx: `団体番号を入力してください`
                                      }
                                    }
                                  })
                                }
                                return _b;
                              },
                            ])
                            _sLdrz.hide();
                            return _b;
                          },
                        }
                      })

                    ]
                  }
                ]
              }
              : null,
              _bLgn ?
              {
                boxStlz: a(`f/n mb/2 ph/2`),
                cellCs: [
                  {
                    oClds: [

                      $cky == false ?
                      cr.c(TextC.N, {
                        key: -10,
                        textz: {
                          pfx: '※ ブラウザのクッキーを有効にしてください。',
                          stlz: a('tc/rd6 ts/s'),
                        },
                      })
                      : null,

                      cr.c(MsgC.N, {
                        key: -10,
                        abtType: 'lgn2Cmnz',
                        cz: {
                          ls: [
                            {
                              mkrCz: {
                                textz: {
                                  pfx: '※',
                                }
                              },
                              msgCz: {
                                textz: {
                                  pfx: '指定したメールアドレス宛に確認コードが送信されない場合は、使用しているメールアプリや通信キャリアの受信設定もご確認ください。',
                                },
                              }
                            },
                            {
                              mkrCz: {
                                textz: {
                                  pfx: '※',
                                }
                              },
                              msgCz: {
                                textz: {
                                  pfx: '正しい確認コードを入力したにも関わらずログインに失敗する場合は、システムに登録されているメールアドレスもご確認ください。',
                                },
                              }
                            },
                            {
                              mkrCz: {
                                textz: {
                                  pfx: '※',
                                }
                              },
                              msgCz: {
                                textz: {
                                  pfx: '本システムは、最新版の Chrome, Safari, Edge, FireFox にてご利用いただけます。',
                                },
                              }
                            },
                          ]
                        }
                      }),

                    ]
                  }
                ]
              }
              : null,
              {
                boxStlz: a('f/1'),
                cellCs: [
                ]
              },
            ]
          }),

          cr.c(IccvFtr, {
            key: -20,
          })

        ],
      },
    })
  );
};
